import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getDate/index.js';

var require$$22 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$22 as default };
